import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import selectDropdown from "../../../../custom/SelectDropdown";
import { MasterApi, TemplateApi } from "../../../../App/api/setting";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import CustomModal from "../../../../custom/modal/customModal";
import { MdDelete } from "react-icons/md";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import { UsersApi } from "../../../../App/api/users.api";

const AddCancellationReasonModal = ({
  isOpen,
  onClose,
  data,
  fetchAllData,
  value,
}) => {
  // Fetch user role data

  // Initialize formik
  const formik = useFormik({
    initialValues: {
      name: "",
      user_role: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
      .required("Name is required"),
      user_role: Yup.string().required("User role is required"),
    }),
    onSubmit: async (values) => {
      try {
        if (data?._id) {
          const res = await TemplateApi.master.updateCancellationReason(
            data?._id,
            values
          );
          toast.success("Updated Cancellation Reason successfully");
          fetchAllData();
        } else {
          const res = await TemplateApi.master.createCancellationReason(values);
          toast.success("Created Cancellation Reason successfully");
          fetchAllData();
        }
      } catch (err) {
        // console.log(err);
      }

      handleClose(); // Close the modal after form submission
    },
  });

  // Update formik values when the data prop changes
  useEffect(() => {
    if (data) {
      formik.setValues({
        name: data?.name || "",
      });
    }
  }, [data, isOpen]);

  const handleClose = () => {
    formik.resetForm(); // Reset the form when closing
    onClose();
  };

  useEffect(() => {
    if (!isOpen) {
      formik.resetForm(); // Reset the form when the modal is closed
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <CustomModal isOpen={isOpen} onClose={handleClose} title="Add Details">
      <form onSubmit={formik.handleSubmit} className="mt-4">
        <div className="mb-4">
          <label className="block text-gray-700">User Role</label>
          <select
            name="user_role"
            value={formik.values.user_role}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
            className={`mt-1 p-2 block w-full border ${
              formik.touched.user_role && formik.errors.user_role
                ? "border-red-500"
                : "border-gray-300"
            } rounded-md shadow-sm focus:ring focus:ring-opacity-50`}
          >
            <option value="" label="Select a user role" />
            {value?.data.map((role) => (
              <option key={role._id} value={role._id} label={role.name} />
            ))}
          </select>
          {formik.touched.user_role && formik.errors.user_role && (
            <p className="text-red-500 text-sm mt-1">
              {formik.errors.user_role}
            </p>
          )}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Cancellation Reason</label>
          <textarea
            type="text"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`mt-1 p-2 block w-full border ${
              formik.touched.name && formik.errors.name
                ? "border-red-500"
                : "border-gray-300"
            } rounded-md shadow-sm focus:ring focus:ring-opacity-50`}
          />
          {formik.touched.name && formik.errors.name && (
            <p className="text-red-500 text-sm mt-1">{formik.errors.name}</p>
          )}
        </div>
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={handleClose}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="bg-[#e34e4e] text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Save
          </button>
        </div>
      </form>
    </CustomModal>
  );
};

export default AddCancellationReasonModal;
